import { render, staticRenderFns } from "./partnerInfo.vue?vue&type=template&id=31344f09&scoped=true&"
import script from "./partnerInfo.vue?vue&type=script&lang=js&"
export * from "./partnerInfo.vue?vue&type=script&lang=js&"
import style0 from "./partnerInfo.vue?vue&type=style&index=0&id=31344f09&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31344f09",
  null
  
)

export default component.exports